import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi, type ProductListParams } from '../api/products-api';

import { productKeys } from './product-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function productListQueryOptions(params: ProductListParams) {
  return queryOptions({
    queryKey: productKeys.list(params),
    queryFn: () => productsApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useProducts(params: ProductListParams) {
  return useQuery(productListQueryOptions(params));
}
